import {
  scaffolderPlugin,
  createScaffolderFieldExtension,
} from '@backstage/plugin-scaffolder';
import { GCPSubnetSelectorFieldExtension } from './GCPSubnetSelectorFieldExtension';

export const GCPSubnetSelectorExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GCPSubnetSelector',
    component: GCPSubnetSelectorFieldExtension,
  }),
);